import { v_InvoiceNoteBus } from './v_InvoiceNoteBus';
import { BaseBus } from './BaseBus';
import { LineItemsSummary } from './LineItemsSummary';
import { OrderDetailsBus } from './OrderDetailsBus';
import { CommonFunctions } from '../static/common-functions';
import { v_OrderBus } from './v_OrderBus';

export class AdditionalOrderData extends BaseBus
{
    constructor(data: AdditionalOrderData = null) {
        super(data);
        let invLines = [];
        if (data !== null) {
            this.lineItemsSummary = data.lineItemsSummary;
            if (CommonFunctions.hasArrayValue(data.lineItems)) {
                for (let i = 0; i < data.lineItems.length; i++) {
                    let newObj: OrderDetailsBus = new OrderDetailsBus(data.lineItems[i]);
                    newObj.ratioXQty = (newObj.ratio ? newObj.ratio : 1) * (newObj.quantity ? newObj.quantity : 1);
                    newObj.ratioXQtyCp = (newObj.ratioCp ? newObj.ratioCp : 1) * (newObj.quantity ? newObj.quantity : 1);
                    invLines.push(newObj);
                }
            }
        }
        this.lineItems = invLines;
    }
    clear() {
        this.lineItemsSummary = new LineItemsSummary();
        this.lineItems = [];
    }
    acctMgr: string;
    amountPaid: number;
    amountDue: number;
    poLimit: number;
    lineItemsSummary: LineItemsSummary;
    lineItems: OrderDetailsBus[];
    detail: v_OrderBus;
    regionName: string;
}
